import Vue from 'vue';
import vueSelect from 'vue-select';

Vue.component('v-select', vueSelect);



// WEBPACK FOOTER //
// ./src/plugins/vue-select.js